import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';

const fetchLogoBusiness = async (
  logoPath: string | null
): Promise<string | null> => {
  if (!logoPath) return null;

  const res = await axios.get(
    `${process.env.REACT_APP_URL_CHECKOUT}/dashboard/v1/public/file/read?file_path=${logoPath}`,
    {
      responseType: 'arraybuffer',
    }
  );

  const arrayBufferView = new Uint8Array(res.data);
  const blob = new Blob([arrayBufferView], {
    type: res.headers['content-type'],
  });
  return URL.createObjectURL(blob);
};

type UseGetImagePublicResult = UseQueryResult<string | null, unknown>;

const useGetImagePublic = (
  logoPath: string | null
): UseGetImagePublicResult => {
  return useQuery({
    queryKey: ['imagePublic', logoPath],
    queryFn: () => fetchLogoBusiness(logoPath),
    enabled: !!logoPath,
    staleTime: 1000 * 60 * 5,
  });
};

export default useGetImagePublic;
